import { useRouter } from 'next/router';

import { Box, Toast, useToast } from '@zillow/constellation-10';

import { useGetListingDetails, useGetTours } from '../../../../hooks/queries/properties';

import ListingTour from './components/ListingTour';

import { useAuth } from '../../../AuthProvider';

type Props = {
  isRelistingFieldset?: boolean;
};

const ListingTourFormField = ({ isRelistingFieldset = false }: Props) => {
  const router = useRouter();
  const { user } = useAuth();
  const { enqueueToast } = useToast();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails } = useGetListingDetails(listingAlias);
  const { vrModels = [], externalTours = [] } = useGetTours(listingAlias, listingDetails);

  const isMultifamily = listingDetails?.isMultifamily ?? false;
  const isFeed = listingDetails?.isFeed ?? false;
  const isArchived = listingDetails?.isArchived ?? false;
  const isUpdateListingRestricted = listingDetails?.restrictions?.isUpdateListingRestricted ?? false;
  const isSelfServeOnboardingInProgress =
    listingDetails?.selfServeOnboardingStatus?.isSelfServeOnboardingInProgress ?? false;
  const isSSOBUpdateRestricted = listingDetails?.selfServeOnboardingStatus?.isUpdateRestricted ?? false;

  const canUpdateListing = user?.features?.canUpdateListing ?? false;

  const isDisabled =
    !canUpdateListing ||
    isArchived ||
    isUpdateListingRestricted ||
    (isSelfServeOnboardingInProgress && isSSOBUpdateRestricted);
  const is3dTourDisabled = isFeed ? isArchived || isUpdateListingRestricted : isDisabled;

  const updateStatusMessage = (message: string, tone?: 'critical' | 'success' | 'warning' | 'info') => {
    enqueueToast(<Toast tone={tone}>{message}</Toast>);
  };

  return (
    <Box css={{ width: '100%' }} data-testid="ListingTourFormField">
      <ListingTour
        tourType={isMultifamily ? 'amenity' : 'singleFamily'}
        isDisabled={is3dTourDisabled}
        vrModels={vrModels}
        externalTours={externalTours}
        isMultifamily={isMultifamily}
        updateStatusMessage={updateStatusMessage}
        isRelistingFieldset={isRelistingFieldset}
      />
    </Box>
  );
};

export default ListingTourFormField;
